import styled from '@emotion/styled';

const Container = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const S = { Container };

export default S;
